import React from "react";
import Plus from "../../assets/svgs/Plus";
import Header from "../components/Header";

function SignleCompany() {
  return (
    <div className="w-full sm:w-[300px]">
      <div className="bg-gray-100 shadow-xl p-3 m-3 flex flex-col justify-center items-center text-center space-y-5">
        <div className="w-16 h-16 rounded-full bg-gray-500"></div>
        <p className="px-6 py-1.5 text-sm bg-pink-500 text-white rounded">
          Company Name
        </p>

        <div>
          <p className="font-medium mb-1.5">Description About The Company</p>
          <p>
            Just a small explantion of the company, maybe some notes or any
            informtaion needed.
          </p>
        </div>

        <div className="w-full text-sm flex justify-between">
          <p>Employees</p>
          <p>Total Employees 15</p>
        </div>

        <div className="w-full md:w-[280x] mx-auto overflow-x-auto flex justify-start items-center">
          {new Array(15).fill("").map((user, i) => (
            <div key={i}>
              <div className="w-8 h-8 mx-3 rounded-full shadow bg-gray-200"></div>
              <p>
                <small>Martin</small>
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const CompanyList = ({ LeftNavRef }) => {
  return (
    <div className="w-full px-4 md:px-10 pb-10">
      <Header />
      {/* <h2 className="text-lg mb-2">Company</h2>
      <div className="w-full flex justify-end">
        <button className="flex space-x-2 items-center px-4 py-1.5 text-base rounded focus:ring">
          <span>Add Company</span>
          <span className="w-5 h-5 flex items-center justify-center rounded-full shadow bg-pink-500 text-white">
            <Plus />
          </span>
        </button>
      </div> */}

      {/* Companies */}
      <div className="w-full flex flex-wrap justify-center">
        <SignleCompany />
        <SignleCompany />
        <SignleCompany />
        <SignleCompany />
      </div>
    </div>
  );
};

export default CompanyList;
